module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_EspacoGourmet.cb0d723b.jpg";